module.exports = __webpack_public_path__ + "img/Milk.81829e9a.svg";